import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#A7F3D0',
} as const

export const resources = {
  loginBg: '/images/novelsprig/login/login-bg.svg',
  logo: '/images/novelsprig/logo.svg',
  novel: '/images/novelsprig/wordmark.svg',
  facebookIcon: '/images/novelsprig/login/icon-facebook-logo.png',
  googleIcon: '/images/novelsprig/login/icon-google-logo.png',
  appleIcon: '/images/novelsprig/login/icon-apple-logo.png',
  emailIcon: '/images/novelsprig/login/icon-email.svg',
  emailCodeIcon: '/images/novelsprig/login/icon-email-code.svg',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
